export const expectedContactHeaders: string[] = [
  "id",
  "漢字（姓）",
  "漢字（名）",
  "かな（名）（任意）",
  "かな（姓）（任意）",
  "英字（名）（任意）",
  "英字（姓）（任意）",
  "メールアドレス（任意）",
  "役職名 （任意）",
  "会社名 （任意）",
  "会社電話番号 （任意）",
  "会社FAX番号 （任意）",
  "電話番号（任意）",
  "会社の住所（任意）",
  "会社郵便番号 （任意）",
  "会社ホームページ （任意）",
  "その他情報（任意）",
  "削除フラグ",
];

export const expectedUserHeaders: string[] = [
  "id",
  "漢字（名）",
  "漢字（姓）",
  "かな（名）",
  "かな（姓）",
  "権限　（１：一般者、　２：管理者、　３：連絡先）",
  "一斉発信グループコード（任意）",
  "部署コード（任意）",
  "役職（任意）",
  "支社名 （任意）",
  "支社住所（任意）",
  "支社電話番号 （任意）",
  "支社FAX番号 （任意）",
  "メールアドレス（任意）",
  "メールアドレス 2（任意）",
  "アカウント状態（有効：TRUE、無効：FALSE）",
  "電話番号",
  "電話番号 2（任意）",
  "ユーザーID",
  "ログインパスワード",
  "利用アプリ",
  "その他情報（任意）",
  "削除フラグ",
];

export const expectedDepartmentHeaders: string[] = [
  "id",
  "部署コード",
  "部署名",
  "部署名かな（任意）",
  "親部署コード（任意）",
  "部署概要欄（任意）",
  "削除フラグ",
];
